import { Group, QredLogo, useWindowProperties } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import MainMenu from '~/components/shared/Menu/MainMenu';
import { CountryCode } from '~/enums';
import { RootState } from '~/store';
import { navbarHeight } from '~/styles/index.css';
import { StyledHeader } from './Header.styled';

const Header = () => {
  const market = useSelector((state: RootState) => state.intl.market);
  const isQeld = market === CountryCode.NL;
  const { isMobile } = useWindowProperties();

  return (
    <StyledHeader component="header">
      <Group
        justify="space-between"
        px={isMobile ? '16px' : '120px'}
        miw="240px"
        mih={navbarHeight}
        style={{ alignItems: 'center' }} // using the "align" prop from Group component causes issues with the children inside also getting "text-align: center", which is not what we want
      >
        <QredLogo width={65} qeld={isQeld} />
        <MainMenu showText={!isMobile} />
      </Group>
    </StyledHeader>
  );
};

export default Header;
